import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as resources from "../../constants/resources";
import * as settings from "../../constants/settings";
import * as navigationActions from "../../actions/navigationActions";
import * as rccActions from "../../actions/rccActions";
import * as gammaMachineActions from "../../actions/intergammaMachineActions";

import QuickTintModalComponent from "../../components/global/modal/QuickTintModal";
import QuickTintModalGammaComponent from "../../components/global/modal/QuickTintModalGamma";

class QuickTintModal extends Component {
    closeModal = () => {
        this.props.dispatchCloseQuickTintModalAction();
    };

    startQuickDispense = (formula) => {
        this.props.dispatchUserAuthenticateModal(
            componentTypes.MODAL_NO_TAB,
            rccActions.initQuickDispensing(formula, true, this.props.redlikeSoftware)
        );
    };

    loadQuickFormula = (formula) => {
        this.props.dispatchInitQuickDispensingAction(formula, false, true);
    };

    openSettings = () => {
        this.props.dispatchSetMenuItemAction();
        this.props.dispatchShowMenu();
    };

    quickPrint = (printerName, template, formula, formulaUnits) => {
        this.props.dispatchPrintFormulaAction(
            printerName,
            template,
            formula,
            formulaUnits,
            this.props.pos,
            this.props.clientIdentifier,
            this.props.printAsImage,
            this.props.loggedUser.login,
            this.props.tintometricSystem === null ? null : this.props.tintometricSystem.name
        );
    };

    render() {
        if (this.props.gammaSoftware) {
            return (
                <QuickTintModalGammaComponent
                    tabId={this.props.tabId}
                    id={this.props.id}
                    loggedUser={this.props.loggedUser}
                    rccModule={this.props.rccModule}
                    activeDatabase={this.props.activeDatabase}
                    databaseList={this.props.databaseList}
                    machine={this.props.machine}
                    databaseColorantList={this.props.databaseColorantList}
                    colorantList={this.props.colorantList}
                    canisterList={this.props.canisterList}
                    dispensingFormula={this.props.dispensingFormula}
                    dispensingInProgress={this.props.dispensingInProgress}
                    connectedRcc={this.props.connectedRcc}
                    unit={this.props.unit}
                    shotsName={this.props.shotsName}
                    shotsCoef={this.props.shotsCoef}
                    printerList={this.props.printerList}
                    templateName={this.props.templateName}
                    templateList={this.props.templateList}
                    sorting={this.props.sorting}
                    visibleUnits={this.props.visibleUnits}
                    selectedPrinter={this.props.selectedPrinter}
                    printOnRequest={this.props.printOnRequest}
                    closeModal={this.closeModal}
                    startQuickDispense={this.startQuickDispense}
                    quickPrint={this.quickPrint}
                    setActiveDatabase={this.props.dispatchSetActiveDatabase}
                />
            );
        }

        return (
            <QuickTintModalComponent
                redlikeSoftware={this.props.redlikeSoftware}
                tabId={this.props.tabId}
                id={this.props.id}
                loggedUser={this.props.loggedUser}
                machine={this.props.machine}
                colorantList={this.props.colorantList}
                canisterList={this.props.canisterList}
                dispensingFormula={this.props.dispensingFormula}
                dispensingInProgress={this.props.dispensingInProgress}
                connectedRcc={this.props.connectedRcc}
                unit={this.props.unit}
                shotsName={this.props.shotsName}
                shotsCoef={this.props.shotsCoef}
                selectedPrinter={this.props.selectedPrinter}
                printerList={this.props.printerList}
                templateName={this.props.templateName}
                templateList={this.props.templateList}
                sorting={this.props.sorting}
                printOnRequest={this.props.printOnRequest}
                visibleUnits={this.props.visibleUnits}
                generateColorPreview={this.props.generateColorPreview}
                closeModal={this.closeModal}
                openSettings={this.openSettings}
                startQuickDispense={this.startQuickDispense}
                loadQuickFormula={this.loadQuickFormula}
                quickPrint={this.quickPrint}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        redlikeSoftware: store.module.redlikeSoftware,
        gammaSoftware: store.module.gammaSoftware,
        loggedUser: store.login.loggedUser,
        rccModule: store.module.rccModule,
        activeDatabase: store.server.activeDatabase,
        databaseList: store.server.databaseList,
        machine: store.rcc.machine,
        databaseColorantList: store.global.colorantList,
        colorantList: store.global.allColorantList,
        canisterList: store.rcc.canisterList,
        dispensingFormula: store.rcc.dispensingFormula,
        dispensingInProgress: store.rcc.dispensingFormula !== null,
        connectedRcc: store.rcc.connected,
        unit: store.settings.formulaUnits === settings.UNIT_MANUAL ? settings.UNIT_ML : store.settings.formulaUnits,
        shotsName: store.settings.shotsName,
        shotsCoef: store.settings.shotsCoef,
        selectedPrinter: store.settings.printer,
        printerList: store.rcc.printerList,
        templateName: store.settings.printerTemplateQuickTint,
        templateList: store.rcc.templateList,
        pos: store.global.posInfo,
        sorting: store.settings.quickTintSortingType,
        visibleUnits: store.settings.visibleUnits,
        printOnRequest: store.settings.printOnRequest,
        clientIdentifier: store.module.clientIdentifier,
        printAsImage: store.settings.printAsImage,
        generateColorPreview: store.settings.generateColorPreview,
        tintometricSystem: store.global.tintometricSystem
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseQuickTintModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.QUICK_TINT_MODAL));
        },
        dispatchInitQuickDispensingAction: (formula, dispense, load) => {
            dispatch(rccActions.initQuickDispensing(formula, dispense, load));
        },
        dispatchPrintFormulaAction: (
            printerName,
            template,
            formula,
            formulaUnits,
            pos,
            clientIdentifier,
            printAsImage,
            userName,
            tintometricSystem
        ) => {
            dispatch(
                rccActions.printFormulaFromQuickTint(
                    printerName,
                    template,
                    formula,
                    formulaUnits,
                    pos,
                    clientIdentifier,
                    printAsImage,
                    userName,
                    tintometricSystem
                )
            );
        },
        dispatchSetMenuItemAction: () => {
            dispatch(navigationActions.setMenuItem(resources.MENU_INTERFACE_SETTIGNS, resources.SUBMENU_QUINT_TINT));
        },
        dispatchShowMenu: () => {
            dispatch(navigationActions.showMenu());
        },
        dispatchUserAuthenticateModal: (tabId, action) => {
            dispatch(navigationActions.userAuthentication(tabId, action));
        },
        dispatchSetActiveDatabase: (databaseName) => {
            dispatch(gammaMachineActions.setActiveDatabase(databaseName));
        }
    };
};

export default QuickTintModal = connect(mapStoreToProps, mapDispatchToProps)(QuickTintModal);
